import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DialogTitle from "@material-ui/core/DialogTitle";
import * as yup from "yup";
import { ERROR_MESSAGE, REQUIRED_MESSAGE } from "../../constants";
import {
  Backdrop,
  CircularProgress,
  FormControl,
  Grid,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { defaultValuesCost } from "./models";
import { useStateValue } from "../../context/store";
import { createRepresentatationCost } from "../../actions/contract-actions";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";
import { withRouter } from "react-router";

const useStyles = makeStyles((theme) => ({
  root: {
    "&::-webkit-scrollbar": {
      width: 6,
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.1)`,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#BAE5F9",
      outline: `1px solid #ffffff`,
      borderRadius: 10,
    },
  },
}));

const DialogCost = (props) => {
  const { open, setOpen, data, handleClose, contractId, setRefresh, refresh } =
    props;
  const classes = useStyles();
  const [{}, dispatch] = useStateValue();
  const [isAcceptDisabled, setIsAcceptDisabled] = useState(false);
  var currentDate = new Date();
  currentDate.setMinutes(
    currentDate.getMinutes() + currentDate.getTimezoneOffset()
  );
  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });
  const fullName = data?.employee?.fullName
    ? data?.employee?.fullName
    : `${data?.employeeData?.firstName} ${
        data?.employeeData?.secondName ?? ""
      } ${data?.employeeData?.surname} ${
        data?.employeeData?.secondSurname ?? ""
      }`;
  const document = data?.employee?.document
    ? data?.employee?.document
    : data?.employeeData?.document;

  const schema = yup.object().shape({
    fullName: yup.string().nullable().required(REQUIRED_MESSAGE),
    document: yup.string().nullable().required(REQUIRED_MESSAGE),
    cost: yup
      .string()
      .nullable(true)
      .required(REQUIRED_MESSAGE)
      .typeError("Ingrese un valor valido")
      .max(20, "Ingrese máximo 20 dígitos")
      .min(5, "Ingrese minimo 5 dígitos"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValuesCost,
    mode: "all",
    reValidateMode: "onChange",
  });

  const closeMessage = () => {
    setMessage((anterior) => ({
      ...anterior,
      open: false,
    }));
    setOpen(!open);
  };

  const closeMessagecost = () => {
    closeMessage();
    props.history.push("/dashboard/contracts");
  };

  const createCost = async (dataForm) => {
    setIsAcceptDisabled(true);
    setMessage({ ...message, open: false });

    const saveResponse = await createRepresentatationCost(
      {
        contractId: contractId,
        value: removeNonNumeric(dataForm.cost),
      },
      dispatch
    );

    if (
      saveResponse &&
      saveResponse.status >= 200 &&
      saveResponse.status < 399
    ) {
      setTimeout(function () {
        setMessage({
          description: `Sus gastos de representación han sido generados de manera exitosa`,
          textButtonSubmit: "Aceptar",
          handleClick: props ? closeMessagecost : closeMessage,
          oneButtons: true,
          type: "SUCCESS",
          open: true,
        });
        if (setRefresh && typeof setRefresh === "function") {
          setRefresh(!refresh);
        }
      }, 200);
      setIsAcceptDisabled(false);
    } else {
      dispatch({
        type: "OPEN_SNACKBAR",
        openMessage: {
          open: true,
          message: saveResponse?.data?.detail
            ? saveResponse?.data?.detail
            : ERROR_MESSAGE,
        },
      });
      setIsAcceptDisabled(false);
    }
  };
  const addDots = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, "");

  const handleSalaryKeyPress = (e) => {
    const { value } = e.target;
    let sal = addDots(removeNonNumeric(value));
    setValue("cost", sal);
  };

  return (
    <div>
      <Backdrop
        //className={classes.backdrop}
        style={{ zIndex: "9999" }}
        open={isAcceptDisabled}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {message.open && (
        <ModalConfirmBase
          description={message.description}
          textButtonSubmit={message.textButtonSubmit}
          handleClick={message.handleClick}
          handleClickOut={message.handleClickOut}
          oneButtons={message.oneButtons}
          type={message.type}
          open={message.open}
        />
      )}
      <Dialog
        PaperProps={{
          style: { borderRadius: "16px", padding: "30px", width: "400px" },
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            color: "#7EBDCE",
            width: "100%",
            margin: "auto",
            textAlign: "center",
          }}
        >
          <InfoOutlinedIcon style={{ fontSize: "90px" }} />
        </DialogTitle>
        <DialogContent style={{ textAlign: "center" }}>
          <p>Generar Gastos de Representación</p>
        </DialogContent>
        <form onSubmit={handleSubmit(createCost)}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  style={{ backgroundColor: "#e0e0e0" }}
                  InputProps={{ readOnly: true }}
                  InputLabelProps={{ shrink: true }}
                  inputRef={register}
                  variant="outlined"
                  className={classes.field}
                  type="text"
                  autoComplete="off"
                  label="Nombre *"
                  name="fullName"
                  size="small"
                  defaultValue={fullName}
                  error={
                    !!errors.hasOwnProperty("fullName") &&
                    errors["fullName"].message
                  }
                  helperText={
                    errors.hasOwnProperty("fullName") &&
                    errors["fullName"].message
                  }
                />
              </FormControl>

              <FormControl fullWidth style={{ paddingTop: "20px" }}>
                <TextField
                  style={{ backgroundColor: "#e0e0e0" }}
                  fullWidth
                  defaultValue={document}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ readOnly: true }}
                  inputRef={register}
                  variant="outlined"
                  className={classes.field}
                  type="text"
                  autoComplete="off"
                  label="Número de cédula *"
                  name="document"
                  size="small"
                  error={
                    !!errors.hasOwnProperty("document") &&
                    errors["document"].message
                  }
                  helperText={
                    errors.hasOwnProperty("document") &&
                    errors["document"].message
                  }
                />
              </FormControl>

              <FormControl fullWidth style={{ paddingTop: "20px" }}>
                <TextField
                  fullWidth
                  inputRef={register}
                  placeholder="0.00"
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                  error={
                    !!errors.hasOwnProperty("cost") && errors["cost"].message
                  }
                  helperText={
                    errors.hasOwnProperty("cost") && errors["cost"].message
                  }
                  onKeyUp={handleSalaryKeyPress}
                  type="text"
                  autoComplete="off"
                  label="Valor"
                  name="cost"
                  size="small"
                />
              </FormControl>
            </Grid>
          </Grid>

          <DialogActions
            style={{ justifyContent: "space-around", paddingTop: "40px" }}
          >
            <Button
              onClick={handleClose}
              color="primary"
              variant="outlined"
              style={{ color: "#7EBDCE", borderColor: "#E1E1E1" }}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              color="primary"
              disabled={isAcceptDisabled}
              autoFocus
              style={{ backgroundColor: "#7EBDCE", color: "#ffffff" }}
            >
              Aceptar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};
export default withRouter(DialogCost);
